
import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ExternalAuthDto } from 'src/app/services/webapiclient.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

declare const AppleID: any;

@Component({
    selector: 'app-apple-login',
    templateUrl: './apple-login.component.html',
    styleUrl: './apple-login.component.scss',
    standalone: false
})
export class AppleLoginComponent implements OnInit {

  //Apple ClientId és redirect URL
  appleClientId = `${environment.appleClientId}`;
  appleRedirectURL: string;
  appleRedirectURLPre = `${environment.appleRedirectURLPre}`;
  appleRedirectURLKog = `${environment.appleRedirectURLKog}`;

  authDTO: ExternalAuthDto = <ExternalAuthDto>{};;
  error = '';

  constructor(private http: HttpClient,
              private authenticationService: AuthenticationService,
              private router: Router,
              @Inject(L10N_LOCALE) public locale: L10nLocale
              
    
  ) { }

  ngOnInit(): void {
    if(window.location.href.includes('predemplatform')){
      this.appleRedirectURL = this.appleRedirectURLPre;
    }else{
      this.appleRedirectURL = this.appleRedirectURLKog;
    }

    AppleID.auth.init({
      clientId: this.appleClientId,  // Service ID
      scope: 'name email',
      redirectURI: this.appleRedirectURL,
      usePopup: true
    });
  }

  async signIn() {
    try {
      const response = await AppleID.auth.signIn();

      this.authDTO.provider = response.authorization.code;
      this.authDTO.idToken = response.authorization.id_token;
      if (response.user) {
        this.authDTO.email = response.user.email;
        if (response.user.name) {
          this.authDTO.firstName = response.user.name.firstName;
          this.authDTO.lastName = response.user.name.lastName;
        }
      }

      console.log(this.authDTO);

      // Küldd a token-t a backend-nek validálásra
      this.authenticationService.appleLogin(this.authDTO).then(data => {
        this.router.navigate(['/home']);
      }).catch(err => {
        this.error = err;
        // //Ha új ÁSZF van, akkor el kell fogadni.
        // if (err == "Core.NewTerms") this.needAcceptance = true;
        // this.loading = false;
      });


    } catch (err) {
      console.error('❌ Apple login hiba:', err);
    }
  }
}
